import {ISurveyResultSubQuestion} from "./ISurveyResultSubQuestion";
export class ISurveyResultQuestion {
  description: string;
  __questions:Array<ISurveyResultSubQuestion>;
}
